import moment from 'moment'
import { app } from '../../main'

export default {
  methods: {
    formatDate (date) {
      if (!date) return ''
      return moment(moment.utc(date)).local().format('YYYY-MM-DD HH:mm:ss')
    },
    formatDateDateOnly (date) {
      if (!date) return ''
      return moment(moment.utc(date)).local().format('YYYY-MM-DD')
    },
    formatDateTimeOnly (date) {
      if (!date) return ''
      return moment(moment.utc(date)).local().format('HH:mm:ss')
    },
    formatDateNonUtc (date) {
      if (!date) return ''
      return moment(date).local().format('YYYY-MM-DD HH:mm:ss')
    },
    formatDateShort (date) {
      if (!date) return ''
      return moment(moment.utc(date)).local().format('ddd D/M').replace(/./, first => first.toUpperCase()) // mon 8/2 => Mon 8/2
    },
    formatDateWeekOnly (date) {
      if (!date) return ''
      const localDate = moment(moment.utc(date)).local()
      return app.$t('Week') + ' ' + localDate.isoWeek() + '-' + localDate.format('YY')
    }
  }
}
